import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Header from './components/Header';
import Footer from './components/Footer';
import PageSkeleton from './components/PageSkeleton';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import GoToTopButton from './components/GoToTopButton';
import { HelmetProvider } from 'react-helmet-async';


/* ===== Lazy Pages ===== */
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Products = lazy(() => import('./pages/Products'));
const Careers = lazy(() => import('./pages/Careers'));
const Clients = lazy(() => import('./pages/Clients'));
const Contact = lazy(() => import('./pages/Contact'));
const PrivacyPolicy = lazy(() => import('./pages/legal/PrivacyPolicy'));
const Terms = lazy(() => import('./pages/legal/Terms'));
const Disclaimer = lazy(() => import('./pages/legal/Disclaimer'));
const CookiePolicy = lazy(() => import('./pages/legal/CookiePolicy'));
const NotFound = lazy(() => import('./pages/NotFound'));


const theme = createTheme({
  palette: {
    primary: {
      main: '#2E7D32',
      light: '#4CAF50',
      dark: '#1B5E20',
    },
    secondary: {
      main: '#FF9800',
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  shape: {
    borderRadius: 10,
  },
});

function App() {
  return (
     <HelmetProvider>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
  <ScrollToTop />
  <GoToTopButton/>

        <div className="App">
        
          <Header />
          <main style={{ minHeight: 'calc(100vh - 140px)' }}>
            <Suspense fallback={<PageSkeleton />}>
             <Routes>
  <Route path="/" element={<Home />} />
  <Route path="/about" element={<About />} />
  <Route path="/products" element={<Products />} />
  <Route path="/careers" element={<Careers />} />
  <Route path="/clients" element={<Clients />} />
  <Route path="/contact" element={<Contact />} />

  {/* Legal Pages */}
  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
  <Route path="/terms" element={<Terms />} />
  <Route path="/disclaimer" element={<Disclaimer />} />
  <Route path="/cookie-policy" element={<CookiePolicy />} />

  {/* 404 Page */}
  <Route path="*" element={<NotFound />} />
</Routes>

            </Suspense>
          </main>

          <Footer />

        </div>
      </Router>
    </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
